import { EquipmentDocument } from '../Equipment/queryBuilder';
import { create } from '../replication-v2/FamilyMember/create';
import { FamilyMember } from '../replication-v2/FamilyMember/FamilyMember';
import { ConfigBuilder, doNotAutoSync, pull, replicate } from '../replication-v2/replicate';
import { RxdbCollectionNameV2 } from '../replication-v2/RxdbCollectionNameV2';
import { SiteDocument } from '../Site/queryBuilder';
import { WorkOrderDocument, workOrdersPullQueryBuilder } from './queryBuilder';

export function workOrdersFamilyMember(
  configBuilder: ConfigBuilder,
  equipment: FamilyMember<EquipmentDocument>,
  sites: FamilyMember<SiteDocument>,
): FamilyMember<WorkOrderDocument> {
  const syncConfig = configBuilder<WorkOrderDocument>(RxdbCollectionNameV2.WORK_ORDERS);
  doNotAutoSync(syncConfig);

  pull(syncConfig, workOrdersPullQueryBuilder);

  const replicationState = replicate(syncConfig);
  return create(RxdbCollectionNameV2.WORK_ORDERS, replicationState, [equipment, sites]);
}
